import React, { Component } from 'react';
import {
    Form,
    Select,
    TreeSelect,
    InputNumber,
    Tree,
    Radio,
    message,
    Button,
    Upload,
    Icon,
    Modal,
    Checkbox,
    Row,
    Col,
    Layout,
    Breadcrumb,
    Cascader,
    Input
} from 'antd';
import subapi from '../subapi'
import './index.css';

const { TreeNode } = TreeSelect;
const { Content } = Layout;
const { TextArea } = Input;
const { SHOW_PARENT } = TreeSelect;
const { Option } = Select;
const { Search } = Input;


class AddedReleaseManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            versionjudgement: true,
            versionjudg: true,
            values: 1,
            grayscale: false, //灰度范围
            upgrade: 0, //升级目标
            valuse: [],
            framework: [], //组织架构
            treeData: [],
            lessee: [], //租户
            file_id: "", //上传文件id
            scale_content: "",
            phoneNumber: true,
            value: undefined,
        }
    }

    componentDidMount() {
        this.architectureSearch();
        this.tenantSearch();
    }
    //获取组织架构搜索
    architectureSearch() {
        let token = sessionStorage.getItem('access_token');
        let params = {
            access_token: token,
        };
        subapi.architectureSearch(params).then(res => {
            console.log(res)
            if(!res){
                return
            }
            if(res.code===0){
                this.setState({ framework: res.content })
            }
        })
    }
    //获取租户搜索
    tenantSearch() {
        let token = sessionStorage.getItem('access_token');
        let params = {
            access_token: token,
        };
        subapi.tenantSearch(params).then(res => {
            if(!res){
                return
            }
            if(res.code===0){
                this.setState({ lessee: res.content })
            }
        })
    }
    //搜索组织架构
    tree_search=e=>{
        console.log(e);
        var _this=this;
        let token = sessionStorage.getItem('access_token');
        let params = {
            access_token: token,
            name:e
        };
        subapi.architectureSearch(params).then(function (data) {
            if (data.code === 0) {
                //treeNode.props.dataRef.children = data.content
                // _this.setState({
                //     framework:data.content
                // });
                _this.setState({ framework: data.content })
            } else {
                message.error(data.message);
            }
        })
    }
    jump = () => {
        let token = sessionStorage.getItem('access_token');
        this.props.history.push(`/EditionManagement?access_token=${token}`);
    }

    uploadFiles(upload) {
        let file_id = [];
        if (upload) {
            upload.map(item => {
                return file_id.push(item.response.content.file_id)
            })
        }
        return file_id.join(",");
    }
    PhoneNumber(number = [], organization = [], tenant = []) {
        console.log(number, organization)
        let scale_content = []
        number.map(item => {
            scale_content.push({
                "type": "1",
                "detail": item,
                "name": item
            })
        })
        organization.map(item => {
            console.log(item)
            scale_content.push({
                "type": "2",
                "detail": item[1],
                "name": item[0]
            })
        })
        tenant.map(item => {
            scale_content.push({
                "type": "3",
                "detail": item[0],
                "name": item[1]
            })
        })
        //console.log(JSON.stringify(scale_content))
        return JSON.stringify(scale_content);
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values)
            let app = "";
            let type = "";
            if (values.select) {
                if (values.select[0] === '彩管家' && values.select[1] == 'Android') {
                    app = "cgj"; type = '1'
                } else if (values.select[0] === '彩之云' && values.select[1] == 'ios') {
                    app = 'czy'; type = '2';
                } else if (values.select[0] === '彩管家' && values.select[1] == 'ios') {
                    app = "cgj"; type = '2'
                } else if (values.select[0] === '彩之云' && values.select[1] == 'Android') {
                    app = "czy"; type = '1'
                } else if(values.select[0] === '物业通' && values.select[1] == 'Android'){
                    app='wyt';type='1';
                } else if(values.select[0] === '物业通' && values.select[1] == 'ios'){
                    app='wyt';type='2';
                }
            }
            if (!err) {
                let token = sessionStorage.getItem('access_token');
                let param = {
                    access_token: token
                }
                for (let item in values) {
                    if (values[item]) {
                        switch (item) {
                            case 'select':
                                param['app'] = app;
                                param['type'] = type;
                                break;
                            case 'input-number':
                                param['version'] = values[item];
                                break;
                            case 'version-number':
                                param['min_version'] = values[item];
                                break;
                            case 'upload':
                                param['file_id'] = this.uploadFiles(values.upload);
                                break;
                            case 'restoredBug':
                                param['bug'] = values[item];
                                break;
                            case 'contents':
                                param['func'] = values[item];
                                break;
                            case 'phone':
                                param['scale_content'] = this.PhoneNumber(values.phone, values.organization, values.tenant);
                                break;
                            case 'organization':
                                param['scale_content'] = this.PhoneNumber(values.phone, values.organization, values.tenant);
                                break;
                            case 'tenant':
                                param['scale_content'] = this.PhoneNumber(values.phone, values.organization, values.tenant);
                                break;
                            // case 'phone':
                            //     param['scale_content'] = this.PhoneNumber(values.phone,values.organization);
                            //     break;

                        }
                    }
                }
                console.log(param)
                if (this.state.versionjudgement && this.state.versionjudg && this.state.phoneNumber) {
                    subapi.versionInformation(param).then(res => {
                        if (res.code === 0) {
                            message.success('添加成功');
                            let token = sessionStorage.getItem('access_token'); //获取鉴权token
                            this.props.history.push(`/EditionManagement?access_token=${token}`);
                        } else {
                            message.error('添加失败');
                        }
                    })
                }

            }
        });
    };
    normFile = e => {
        //console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    //判断版本号
    inputOnBlurStaff = ({ target: { value } }) => {
        console.log(this.props.form.getFieldsValue().select);
        var select_val=this.props.form.getFieldsValue().select||[];
        if(select_val[0]==='彩之云'){
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){3}$/);
            var patt2= new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
           // console.log(patt1.test(value))
            if (patt1.test(value)||patt2.test(value)) {
                this.setState({ versionjudgement: true })
            } else {
                this.setState({ versionjudgement: false })
            }
        }else{
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
            if (patt1.test(value)) {
                this.setState({ versionjudgement: true })
            } else {
                this.setState({ versionjudgement: false })
            }
        }
        
    }
    //判断支持最低版本号
    versionOnBlurStaff = ({ target: { value } }) => {
        var select_val=this.props.form.getFieldsValue().select||[];
        if(select_val[0]==='彩之云'){
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){3}$/);
            var patt2= new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
            //console.log(patt1.test(value))
            if (patt1.test(value)||patt2.test(value)) {
                this.setState({ versionjudg: true })
            } else {
                this.setState({ versionjudg: false })
            }
        }else{
            var patt1 = new RegExp(/^([1-9]\d|[1-9])(\.([1-9]\d|\d)){2}$/);
            if (patt1.test(value)) {
                this.setState({ versionjudg: true })
            } else {
                this.setState({ versionjudg: false })
            }
        }
        
    }

    //灰度范围
    tonalOnChange = ({ target: { value } }) => {
        if (value === 1) {
            this.setState({ grayscale: false })
        } else {
            this.setState({ grayscale: true })
        }
        if (!this.state.grayscale) {
            this.setState({ upgrade: 0 })
        }
    }
    //手机号
    onPressEnter = ({ target: { value } }) => {
        console.log(value)
    }
    //升级目标
    upgradeOnChange = ({ target: { value } }) => {
        if (value === 1) {
            this.setState({ upgrade: 1 })
        } else if (value === 2) {
            this.setState({ upgrade: 2 })
        } else if (value === 3) {
            this.setState({ upgrade: 3 })
        }
    }
    structureOnChange = (value, label, extra) => {
        this.setState({ valuse: value });
        console.log(value, label, extra)
    };
    onInputKeyDown = (value) => {
        console.log(value)
        if (!/^([，；,;]*1\d{10}[，；,;]*)*$/.test(value.join(','))) {
            this.setState({ phoneNumber: false })
        } else {
            this.setState({ phoneNumber: true })
        }
        //this.setState({scale_content:value.join(",")})

    }
    // combine = (data) => {
    //     let result = [];
    //     data.map((item, index) => {
    //         result.push({
    //             title: item.name,
    //             value: item.name,
    //             key: index,
    //         })
    //     })
    //     return result;
    // }
    renderTreeNodes = data => {
        let rahmen;
        if (data) {
            rahmen = data.map(item => {
                item.key = item.orgUuid;
                item.title = item.name;
                item.value = [item.name, item.orgUuid];
                item.type = item.orgType;
                if (item.children) {
                    return (
                        <TreeNode title={item.title} value={item.value} type={item.type} key={item.key} dataRef={item}>
                            {this.renderTreeNodes(item.children)}
                        </TreeNode>
                    );
                }
                //console.log(data)
                return <TreeNode title={item.title} value={item.value} type={item.type} key={item.key} dataRef={item} />;
            });
            return rahmen;
        }

    }

    onLoadData = (treeNode) => {
        let _this = this;
        console.log(treeNode.props)
        return new Promise((resolve) => {
            if (!treeNode.props.children || !treeNode.props.children.length) {
                let token = sessionStorage.getItem('access_token');
                let params = {
                    access_token: token,
                    org_uuid: treeNode.props.dataRef.orgUuid
                };
                subapi.architectureSearch(params).then(function (data) {
                    if (data.code === 0) {
                        treeNode.props.dataRef.children = data.content
                        _this.setState({
                            treeData: [..._this.state.treeData],
                        });
                    } else {
                        message.error(data.message);
                    }
                })
            }
            resolve();
        });
    }
    onChangeArea = (value, label, extra) => {
        console.log(value)
        // console.log(this.state.framework)
    }
    //租户
    leaseholder = (data) =>
        data.map(item => {
            return <TreeNode title={item.corpName} value={[item.corpUuid, item.corpName]} key={item.id} />;
        })

    onSelect = (value) => {
        console.log(value)

    }
    // onSearch=(value)=>{
    //     let token = sessionStorage.getItem('access_token');
    //     let params={
    //         access_token:token,
    //         name:value
    //     }
    //     subapi.architectureSearch(params).then(res=>{
    //         console.log(res)
    //     })
    // }
    render() {
        //console.log(this.state.scale_content)
        let token = sessionStorage.getItem('access_token');
        const upalods = {
            name: 'file',
            data: { access_token: token },
            action: `${subapi._baseUrl}/file/upload`,
            // headers: {
            //     authorization: 'authorization-text',
            // },
            //上传文件
            //onChange:this.uploadOnChange
            onChange(info) {
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} 文件上传成功`);
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} 文件上传失败`);
                }
            },

        }
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        let { getFieldDecorator } = this.props.form;
        //let treeData = this.combine(this.state.framework);

        const options = [
            {
                value: '彩管家',
                label: '彩管家',
                children: [
                    {
                        value: 'Android',
                        label: 'Android',
                    },
                    {
                        value: 'ios',
                        label: 'ios',
                    }
                ],
            },
            {
                value: '彩之云',
                label: '彩之云',
                children: [
                    {
                        value: 'Android',
                        label: 'Android',
                    },
                    {
                        value: 'ios',
                        label: 'ios',
                    }
                ],
            },{
                value: '物业通',
                label: '物业通',
                children: [
                    {
                        value: 'Android',
                        label: 'Android',
                    },
                    {
                        value: 'ios',
                        label: 'ios',
                    }
                ],
            },
        ];
        const warning_message=()=>{
            var aaa=this.props.form.getFieldsValue().select||[];
            return aaa[0]==='彩之云'?'版本号必须是四位，x.x.x.x的形式,每位x的范围分别为1-99,0-99,0-99,0-99。 不允许的情况0.x.x.x；01.x.x.x; x.0x.x.x; x.00.x.x； x.x.x.00; x.x.x.0x':'版本号必须是三位，x.x.x的形式,每位x的范围分别为1-99,0-99,0-99。 不允许的情况0.x.x；01.x.x; x.0x.x; x.00.x； x.x.00; x.x.0x';
        }
        return (
            <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                <Layout style={{ height: '100%' }}>
                    <div style={{ display: 'flex' }}>
                        <Content style={{ backgroundColor: 'rgb(242, 244, 245)', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <div style={{ width: '100%', height: 'calc(100vh - 48px)', overflowY: 'auto' }}>
                                    <div style={{ padding: '14px 16px', borderBottom: '1px solid rgb(204, 204, 204)', background: "#fff" }}>
                                        <Breadcrumb>
                                            <Breadcrumb.Item>
                                                <a onClick={this.jump}>发版管理</a>
                                            </Breadcrumb.Item>
                                            <Breadcrumb.Item>
                                                添加版本
                                            </Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>
                                    <Layout id="project_management">
                                        <Content className="content">
                                            <div>
                                                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                                                    <Form.Item label="App类型">
                                                        {getFieldDecorator('select', {
                                                            rules: [{ required: true, message: '请选择App类型!' }],
                                                        })(
                                                            <Cascader
                                                                options={options}
                                                                placeholder="请选择App类型"
                                                                allowClear={false}
                                                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                                            />
                                                        )}
                                                    </Form.Item>

                                                    <Form.Item label="版本号">
                                                        {getFieldDecorator('input-number', {
                                                            rules: [{ required: true, message: '请输入版本号!' }]
                                                        })
                                                            (
                                                                <Input
                                                                    placeholder="请输入版本号"
                                                                    onBlur={this.inputOnBlurStaff} />,
                                                            )}
                                                        {this.state.versionjudgement ? '' : <div style={{ color: 'red', fontSize: '14px' }}>
                                                        {warning_message()}
                                                       </div>}
                                                    </Form.Item>

                                                    <Form.Item label="支持最低版本">
                                                        {getFieldDecorator('version-number', {
                                                            rules: [{ required: true, message: '请输入版本号!' }]
                                                        })
                                                            (
                                                                <Input
                                                                    placeholder="请输入版本号"
                                                                    onBlur={this.versionOnBlurStaff} />,
                                                            )}
                                                        {this.state.versionjudg ? '' : <div style={{ color: 'red', fontSize: '14px' }}>
                                                        {warning_message()}
                                                            </div>}
                                                    </Form.Item>

                                                    <Form.Item label="上传">
                                                        {getFieldDecorator('upload', {
                                                            valuePropName: 'fileList',
                                                            getValueFromEvent: this.normFile,
                                                            rules: [{ required: true, message: '请上传文件!' }]
                                                        })(
                                                            <Upload {...upalods}>
                                                                <Button>
                                                                    <Icon type="upload" /> 点击上传文件
                                                                </Button>
                                                            </Upload>,
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item label="修复的BUG">
                                                        {getFieldDecorator('restoredBug', {
                                                            rules: [{ required: true, message: '请输入修复的BUG!' }]
                                                        })
                                                            (
                                                                <TextArea
                                                                    placeholder="请输入修复的BUG"
                                                                    autosize={{ minRows: 3, maxRows: 5 }}
                                                                />
                                                            )}
                                                    </Form.Item>
                                                    <Form.Item label="发布的内容">
                                                        {getFieldDecorator('contents', {
                                                            rules: [{ required: true, message: '请输入发布的内容!' }]
                                                        })
                                                            (
                                                                <TextArea
                                                                    placeholder="发布的内容"
                                                                    autosize={{ minRows: 3, maxRows: 5 }}
                                                                />
                                                            )}
                                                    </Form.Item>

                                                    <Form.Item label="灰度范围">
                                                        {getFieldDecorator('tonal_range', {
                                                            rules: [{ required: true, message: '请选择灰度范围!' }]
                                                        })(
                                                            <Radio.Group onChange={this.tonalOnChange} >
                                                                <Radio value={1}>
                                                                    全量
                                                                </Radio>
                                                                <Radio value={2}>
                                                                    灰度
                                                                </Radio>
                                                            </Radio.Group>
                                                        )}
                                                    </Form.Item>

                                                    {
                                                        this.state.grayscale ?
                                                            <div>
                                                                <Form.Item label="手机号">
                                                                    {getFieldDecorator('phone')(
                                                                        <Select mode="tags" style={{ width: 500 }} tokenSeparators={[',']}
                                                                            placeholder="请输入手机号，并按Enter键继续"
                                                                            onChange={this.onInputKeyDown}
                                                                            size="large"
                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                        >
                                                                        </Select>

                                                                    )}
                                                                    <Button onClick={()=>{
                                                                        this.props.form.setFieldsValue({"phone":[]})
                                                                    }}>清空手机号</Button>
                                                                    {
                                                                        this.state.phoneNumber ? "" :
                                                                            <div style={{ color: 'red', fontSize: '14px' }}>
                                                                                请输入正确的手机号
                                                                         </div>
                                                                    }
                                                                </Form.Item>
                                                                <Form.Item label="组织架构">
                                                                    {getFieldDecorator('organization')(
                                                                        <TreeSelect
                                                                            showSearch
                                                                            placeholder='请选择'
                                                                            dropdownStyle={{ height: 300 }}
                                                                            style={{ width: 500 }}
                                                                            loadData={this.onLoadData.bind(this)}
                                                                            onSelect={this.onChangeArea}
                                                                            onSearch={this.tree_search}
                                                                            treeCheckable
                                                                            size="large"
                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                        >
                                                                            {this.renderTreeNodes(this.state.framework)}
                                                                        </TreeSelect>

                                                                    )}
                                                                    <Button onClick={()=>{
                                                                        this.props.form.setFieldsValue({"organization":[]})
                                                                    }}>清空组织架构</Button>
                                                                </Form.Item>
                                                                <Form.Item label="租户">
                                                                    {getFieldDecorator('tenant')(
                                                                        <TreeSelect
                                                                            showSearch
                                                                            placeholder='请选择'
                                                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                            style={{ width: 500, }}
                                                                            treeCheckable
                                                                            allowClear
                                                                            treeDefaultExpandAll
                                                                            getPopupContainer={triggerNode => triggerNode.parentNode}
                                                                        >
                                                                            {this.leaseholder(this.state.lessee)}
                                                                        </TreeSelect>
                                                                    )}
                                                                    <Button onClick={()=>{
                                                                        this.props.form.setFieldsValue({"tenant":[]})
                                                                    }}>清空租户</Button>
                                                                </Form.Item>
                                                            </div>
                                                            :
                                                            ""
                                                    }
                                                    <Form.Item wrapperCol={{ span: 12, offset: 6 }} style={{ marginTop: 20 }}>
                                                        <Button type="primary" htmlType="submit">
                                                            确认
                                                        </Button>
                                                    </Form.Item>
                                                </Form>
                                            </div>
                                        </Content>
                                    </Layout>
                                </div>
                            </div>
                        </Content>
                    </div>
                </Layout>
            </div>
        )
    }
}

const AddedRelease = Form.create()(AddedReleaseManagement);
export default AddedRelease;